/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
    PaymentTypeToJSONTyped,
} from './PaymentType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTeacherRequest
 */
export interface CreateTeacherRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    lastName: string;
    /**
     * 
     * @type {number}
     * @memberof CreateTeacherRequest
     */
    payRate: number;
    /**
     * 
     * @type {PaymentType}
     * @memberof CreateTeacherRequest
     */
    paymentType: PaymentType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    preferredName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    biography?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    cellPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    homePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    payrollId?: string | null;
    /**
     * 
     * @type {any}
     * @memberof CreateTeacherRequest
     */
    dateOfBirth?: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateTeacherRequest
     */
    startDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof CreateTeacherRequest
     */
    endDate?: any | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    addressLine3?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    zip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTeacherRequest
     */
    country?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeacherRequest
     */
    isInContactUsMailingList?: boolean | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateTeacherRequest
     */
    workLocationIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof CreateTeacherRequest
     */
    classIds?: Array<ApiUserTasksGetPageParameter> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTeacherRequest
     */
    isFeatured?: boolean | null;
}



/**
 * Check if a given object implements the CreateTeacherRequest interface.
 */
export function instanceOfCreateTeacherRequest(value: object): value is CreateTeacherRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('payRate' in value) || value['payRate'] === undefined) return false;
    if (!('paymentType' in value) || value['paymentType'] === undefined) return false;
    return true;
}

export function CreateTeacherRequestFromJSON(json: any): CreateTeacherRequest {
    return CreateTeacherRequestFromJSONTyped(json, false);
}

export function CreateTeacherRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeacherRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'payRate': json['payRate'],
        'paymentType': PaymentTypeFromJSON(json['paymentType']),
        'preferredName': json['preferredName'] == null ? undefined : json['preferredName'],
        'biography': json['biography'] == null ? undefined : json['biography'],
        'cellPhone': json['cellPhone'] == null ? undefined : json['cellPhone'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'payrollId': json['payrollId'] == null ? undefined : json['payrollId'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'addressLine3': json['addressLine3'] == null ? undefined : json['addressLine3'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'country': json['country'] == null ? undefined : json['country'],
        'isInContactUsMailingList': json['isInContactUsMailingList'] == null ? undefined : json['isInContactUsMailingList'],
        'workLocationIds': json['workLocationIds'] == null ? undefined : ((json['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'classIds': json['classIds'] == null ? undefined : ((json['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'isFeatured': json['isFeatured'] == null ? undefined : json['isFeatured'],
    };
}

export function CreateTeacherRequestToJSON(json: any): CreateTeacherRequest {
    return CreateTeacherRequestToJSONTyped(json, false);
}

export function CreateTeacherRequestToJSONTyped(value?: CreateTeacherRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'payRate': value['payRate'],
        'paymentType': PaymentTypeToJSON(value['paymentType']),
        'preferredName': value['preferredName'],
        'biography': value['biography'],
        'cellPhone': value['cellPhone'],
        'homePhone': value['homePhone'],
        'payrollId': value['payrollId'],
        'dateOfBirth': value['dateOfBirth'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
        'isInContactUsMailingList': value['isInContactUsMailingList'],
        'workLocationIds': value['workLocationIds'] == null ? undefined : ((value['workLocationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'classIds': value['classIds'] == null ? undefined : ((value['classIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'isFeatured': value['isFeatured'],
    };
}

